import * as zod from "zod";

const rateCalculatorSessionSummary_ = zod.object({
  id: zod.string(),
  adminUserId: zod.string(),
  sessionName: zod.string().nullable(),
  teamId: zod.string().nullable(),
  teamName: zod.string().nullable(),
  uploadedFileName: zod.string().nullable(),
  createdAt: zod.string(),
  updatedAt: zod.string(),
});
export const RateCalculatorSessionSummary: zod.ZodType<RateCalculatorSessionSummary> =
  rateCalculatorSessionSummary_;
export interface RateCalculatorSessionSummary extends zod.infer<
  typeof rateCalculatorSessionSummary_
> {}

export const getRateCalculatorSessions = {
  name: "getRateCalculatorSessions" as const,
  input: zod.object({
    search: zod.string().optional(),
    offset: zod.number().optional(),
    limit: zod.number().optional(),
  }),
  output: zod.object({
    sessions: zod.array(rateCalculatorSessionSummary_),
    total: zod.number(),
  }),
};
